module.exports = __webpack_public_path__ + "static/media/icon-2.1eafbf54.svg";